import { useMe } from '../api/hooks'

// Persistent affordance shown at the top of the app when the viewer has
// the site-wide superuser flag. The point is *self-discipline* — to keep
// you from screenshotting elevated views thinking they're normal-user
// POV. Compact and dismissible-by-eye, not modal or interactive.
export const SuperuserBanner = () => {
  const { data: me } = useMe()
  if (!me?.isSuperuser) return null
  return (
    <output
      aria-label="Viewing as superuser"
      style={{
        display: 'block',
        background: 'var(--plum-bg, #f4ebf2)',
        color: 'var(--ink, #2a1f1f)',
        borderBottom: '1px solid var(--line, #d8cdc4)',
        fontFamily: 'var(--font-display)',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
        padding: '4px 12px',
        textAlign: 'center',
      }}
    >
      <span style={{ marginRight: 6 }} aria-hidden>
        ★
      </span>
      Superuser view
    </output>
  )
}
